import { render, staticRenderFns } from "./SatellitesTabs.vue?vue&type=template&id=ad15c8de&scoped=true"
import script from "./SatellitesTabs.vue?vue&type=script&lang=js"
export * from "./SatellitesTabs.vue?vue&type=script&lang=js"
import style0 from "./SatellitesTabs.vue?vue&type=style&index=0&id=ad15c8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad15c8de",
  null
  
)

export default component.exports